<div class="call-notice" [ngClass]="toneClass" *ngIf="notice" role="status" aria-live="polite">
  <div class="call-notice__bar"></div>

  <div class="call-notice__body">
    <div class="call-notice__icon">
      <mat-icon>{{ icon }}</mat-icon>
      <!-- The ring only plays while a call is actually being handed over. -->
      <span class="call-notice__pulse" *ngIf="notice.outcome === 'dialling'"></span>
    </div>

    <div class="call-notice__main">
      <div class="call-notice__title">{{ notice.title }}</div>
      <div class="call-notice__detail">{{ notice.detail }}</div>

      <a
        *ngIf="notice.number"
        class="call-notice__number"
        [href]="'tel:' + notice.number"
        [attr.aria-label]="'Dial ' + notice.number"
      >
        <mat-icon>call</mat-icon>{{ notice.number }}
      </a>
    </div>

    <button
      type="button"
      class="call-notice__close"
      (click)="dismiss.emit()"
      aria-label="Dismiss"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
